import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { Link } from 'react-router-dom';
import { KC_SEARCH_PATH } from '../repository';
import { KC_COLORS } from '../theme';

function SidebarCta({ icon, label, description, buttonLabel, to }) {
  const actionStyles = to
    ? {
        backgroundColor: KC_COLORS.teal,
        color: KC_COLORS.white,
        cursor: 'pointer',
        opacity: 1,
        pointerEvents: 'auto',
      }
    : {
        backgroundColor: KC_COLORS.lightGrey,
        color: KC_COLORS.navy700,
        cursor: 'not-allowed',
        opacity: 0.7,
        pointerEvents: 'none',
      };

  const actionClassName =
    'inline-flex mt-3 items-center justify-center rounded-lg px-3.5 py-2 kc-type-caption font-bold no-underline transition-opacity hover:opacity-90';

  return (
    <div
      className="rounded-2xl border bg-white p-4 text-left"
      style={{ borderColor: KC_COLORS.border }}
      aria-disabled={to ? undefined : true}
    >
      <div className="flex items-start gap-3">
        <span
          className="inline-flex items-center justify-center w-10 h-10 rounded-xl shrink-0"
          style={{ backgroundColor: KC_COLORS.tealLight, color: KC_COLORS.teal }}
        >
          {icon}
        </span>
        <div className="min-w-0">
          <p className="kc-type-body font-bold m-0" style={{ color: KC_COLORS.primaryNavy }}>
            {label}
          </p>
          {description ? (
            <p className="kc-type-caption mt-1 m-0" style={{ color: KC_COLORS.gray600 }}>
              {description}
            </p>
          ) : null}
          {to ? (
            <Link to={to} className={actionClassName} style={actionStyles}>
              {buttonLabel || label}
            </Link>
          ) : (
            <span className={`${actionClassName} select-none`} style={actionStyles}>
              {buttonLabel || label}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export function ArticleToc({ sections, onNavigate }) {
  // Keep TOC focused on readable sections; figures and untitled blocks stay in the body only.
  const tocSections = sections.filter(
    (section) =>
      section.id !== 'title' &&
      section.variant !== 'figure' &&
      section.includeInToc !== false &&
      Boolean(section.title) &&
      !/seo|aeo metadata/i.test(section.title || '')
  );

  return (
    <aside className="kc-article-toc hidden lg:block lg:sticky lg:top-28 h-fit space-y-4 text-left">
      <div
        className="kc-category-sidebar h-fit rounded-2xl border bg-white px-5 pb-5 pt-4 md:px-6 md:pb-6 md:pt-5 text-left"
        style={{ borderColor: KC_COLORS.border }}
      >
        <div className="kc-category-sidebar-header mb-4 md:mb-5">
          <h2
            className="kc-type-h3 text-left m-0"
            style={{ color: KC_COLORS.primaryNavy }}
          >
            In This Article
          </h2>
        </div>

        <nav aria-label="Article sections">
          <ul className="m-0 p-0 list-none space-y-1 text-left">
            {tocSections.map((section) => (
              <li key={section.id}>
                <button
                  type="button"
                  onClick={() => onNavigate(section.id)}
                  className="kc-category-sidebar-link w-full text-left kc-type-body font-semibold"
                >
                  <span className="kc-category-sidebar-dot" aria-hidden="true" />
                  <span className="kc-category-sidebar-text">{section.title}</span>
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <SidebarCta
        icon={<PictureAsPdfOutlinedIcon sx={{ fontSize: 22 }} />}
        label="Download PDF"
        description="Save this chapter for offline review."
        buttonLabel="Coming soon"
      />

      <SidebarCta
        icon={<HelpOutlineOutlinedIcon sx={{ fontSize: 22 }} />}
        label="Ask a Question"
        description="Search the Knowledge Center for answers."
        buttonLabel="Ask a Question"
        to={KC_SEARCH_PATH}
      />
    </aside>
  );
}
